import escapeGQLString from './escapeGQLString';

export default (value) => `"${escapeGQLString(value)}"`;
